import type { BannerEventListenerArgs, BannerEventType } from '@/modules/adv/index'
import type { AdProviderNames } from '@/types'

type BannerOptions = {
    destroy?: () => void
    provider: AdProviderNames
    adUnit?: string
}

export enum BannerState {
    'loading' = 'loading',
    'empty' = 'empty',
    'ready' = 'ready',
    'showing' = 'showing',
    'closed' = 'pending',
}

export enum BannerType {
    'banner' = 'banner',
    'outOfPageBanner' = 'out-of-page-banner',
}

export class Banner extends EventTarget {
    readonly destroy: () => void

    readonly provider: AdProviderNames

    state: BannerState = BannerState.loading

    adUnit?: string

    instreamDuration?: number

    watchedDuration?: number

    type = BannerType.banner

    constructor(options: BannerOptions) {
        super()

        this.destroy = options.destroy || (() => {})
        this.provider = options.provider
        this.adUnit = options.adUnit
    }

    public triggerClosed() {
        if (this.state !== BannerState.closed) {
            this.state = BannerState.closed
            this.dispatch('closed')
        }
    }

    public triggerRewarded(payload: unknown) {
        this.dispatch('rewarded', payload)
    }

    public triggerEmpty() {
        if (this.state !== BannerState.empty) {
            this.state = BannerState.empty
            this.dispatch('empty')
        }
    }

    public triggerViewable() {
        this.dispatch('viewable')
    }

    public triggerRendered() {
        if (this.state !== BannerState.showing) {
            this.state = BannerState.showing
            this.dispatch('rendered')
        }
    }

    public triggerClicked() {
        this.dispatch('clicked')
    }

    public triggerTimer(secondsLeft: number) {
        this.dispatch('timer', { secondsLeft })
    }

    public override addEventListener(...args: BannerEventListenerArgs) {
        super.addEventListener(...args)
    }

    public override removeEventListener(...args: BannerEventListenerArgs) {
        super.removeEventListener(...args)
    }

    public dispatch(event: BannerEventType, payload?: unknown) {
        this.dispatchEvent(new CustomEvent(event, { detail: payload }))
    }
}
